var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiploma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 9.5C18 9.22386 18.2239 9 18.5 9H39V17.5C39 19.433 40.567 21 42.5 21H51V53.5C51 53.7761 50.7761 54 50.5 54H18.5C18.2239 54 18 53.7761 18 53.5V51.207C17.0981 51.7584 16.0118 51.9221 15 51.6902V53.5C15 55.433 16.567 57 18.5 57H50.5C52.433 57 54 55.433 54 53.5V18.3284C54 17.4002 53.6313 16.5099 52.9749 15.8536L44.1464 7.02513C43.4901 6.36875 42.5998 6 41.6716 6H18.5C16.567 6 15 7.56701 15 9.5V19.1674C15.9473 18.7443 16.9523 18.4271 18 18.231V9.5ZM50.877 18H42.5C42.2239 18 42 17.7761 42 17.5V9.12299C42.0086 9.1305 42.017 9.13832 42.0251 9.14645L50.8536 17.9749C50.8617 17.983 50.8695 17.9914 50.877 18Z",
    fill: "#3DE8CA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5 26C17.4624 26 15 28.4624 15 31.5C15 34.5376 17.4624 37 20.5 37C23.5376 37 26 34.5376 26 31.5C26 28.4624 23.5376 26 20.5 26ZM18 31.5C18 30.1193 19.1193 29 20.5 29C21.8807 29 23 30.1193 23 31.5C23 32.8807 21.8807 34 20.5 34C19.1193 34 18 32.8807 18 31.5Z",
    fill: "#3DE8CA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.84516 44.2907L12.9929 38.8388C11.1413 36.9456 10 34.3549 10 31.4976C10 25.6986 14.701 20.9976 20.5 20.9976C26.299 20.9976 31 25.6986 31 31.4976C31 34.355 29.8586 36.9459 28.0068 38.8391L31.1549 44.2917C31.5266 44.9355 31.0908 45.7454 30.3488 45.7899L27.9989 45.931C27.6847 45.9498 27.3977 46.1155 27.2243 46.3782L25.9272 48.3427C25.5176 48.9631 24.5984 48.9355 24.2267 48.2917L20.5925 41.9972C20.5617 41.9974 20.5309 41.9976 20.5 41.9976C20.469 41.9976 20.4379 41.9974 20.407 41.9972L16.7734 48.2907C16.4017 48.9345 15.4824 48.9621 15.0728 48.3417L13.7757 46.3772C13.6023 46.1145 13.3153 45.9488 13.0011 45.93L10.6513 45.7889C9.90923 45.7444 9.47347 44.9345 9.84516 44.2907ZM20.5 23.9976C16.3579 23.9976 13 27.3554 13 31.4976C13 35.6397 16.3579 38.9976 20.5 38.9976C24.6421 38.9976 28 35.6397 28 31.4976C28 27.3554 24.6421 23.9976 20.5 23.9976Z",
    fill: "#3DE8CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiploma);
export default __webpack_public_path__ + "static/media/diploma.da7d3cb030576de532758f70a0f86fe9.svg";
export { ForwardRef as ReactComponent };